module.exports = __webpack_public_path__ + "img/bells.6d78c886.png";